<script lang="ts">
	import FieldError from "$form/Fields/Shared/FieldError.svelte";
	import Label from "$form/Fields/Shared/Label.svelte";
	import Description from "$form/Fields/Shared/Description.svelte";
	import RangeSlider from "$basic/RangeSlider.svelte";

	import { createEventDispatcher } from "svelte";
	export let field: FieldDisplay & { type: "Slider" };
	export let value: ChoiceValue;

	const dispatch = createEventDispatcher();
</script>

<div class="field-label-cover">
	{#if field.labelHTMLComputed && field.settings.hideLabel !== true}
		<Label html="{field.labelHTMLComputed}" />
		{#if field.descriptionHTMLComputed}
			<Description html="{field.descriptionHTMLComputed}" />
		{/if}
	{/if}
</div>
<div class="field-input-cover">
	{#if field.settings.type === "numbers"}
		<RangeSlider
			bind:value="{value}"
			on:blur="{() => {
				dispatch('updateOther', { tainted: true });
				dispatch('updateOther', { active: false });
			}}"
			on:focus="{() => dispatch('updateOther', { active: true })}"
			type="{field.settings.type}"
			name="{field.id}"
			min="{parseFloat(field.settings.min)}"
			max="{parseFloat(field.settings.max)}"
			step="{parseFloat(field.settings.step)}"
			prefix="{field.settings.prefix}"
			suffix="{field.settings.suffix}"
			leftLabel="{field.settings.leftLabel}"
			rightLabel="{field.settings.rightLabel}"
			pips="{true}" />
	{:else}
		<RangeSlider
			bind:value="{value}"
			on:blur="{() => {
				dispatch('updateOther', { tainted: true });
				dispatch('updateOther', { active: false });
			}}"
			on:focus="{() => dispatch('updateOther', { active: true })}"
			type="{field.settings.type}"
			name="{field.id}"
			options="{field.settings.options}" />
	{/if}
	<FieldError
		visible="{field.tainted}"
		valid="{field.valid}"
		errorNumber="{field.errorNumber}"
		errorType="{field.errorType}" />
</div>
